import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import venomContext from "../../context/venomContext";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import classNames from "classnames";

export default function Login() {
  const context = useContext(venomContext);
  const { userLogin } = context;
  const [userInfo, setUserInfo] = useState({ email: "", password: "" });
  const [showPass, setShowPass] = useState(false);
  const theme_color = localStorage.getItem("theme");
  const onChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };
  const togglePassHandler = () => {
    setShowPass(!showPass);
  };
  const onClickHandler = (e) => {
    e.preventDefault();
    const { email, password } = userInfo;
    if (email === "" || password === "") {
      toast.error("All fields are required", {
        position: "bottom-right",
      });
    }
    userLogin(email, password);
  };
  const keyUpHandler = (e) => {
    if (e.keyCode === 13) {
      const { email, password } = userInfo;
      if (email === "" || password === "") {
        toast.error("All fields are required", {
          position: "bottom-right",
        });
      }
      userLogin(email, password);
    }
  };
  return (
    <>
      <Header />
      <div className="signup">
        <form className="main_form p-5">
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email address
            </label>
            <input
              name="email"
              value={userInfo.email}
              type="email"
              className={"form-control input-" + theme_color}
              id="email"
              onKeyUp={keyUpHandler}
              onChange={onChange}
            />
          </div>
          <div className="content-last vlign">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              name="password"
              value={userInfo.password}
              type={showPass !== true ? "password" : "text"}
              className={"form-control input-" + theme_color}
              id="password"
              onKeyUp={keyUpHandler}
              onChange={onChange}
            />
            <div className="show-pass-btn">
              <i
                className={classNames(
                  "fal",
                  { " fa-eye": showPass !== true },
                  { " fa-eye-slash": showPass === true }
                )}
                style={{ cursor: "pointer" }}
                onClick={togglePassHandler}
              ></i>
            </div>
          </div>
          <p className=" mt-1 mb-2 text-end">
            Forgot Password?{" "}
            <Link to={"/pass/reset"} style={{ fontWeight: 600 }}>
              RESET PASSWORD
            </Link>
          </p>
          <button
            type="button"
            onClick={(e) => onClickHandler(e)}
            className={"btn border-0 mb-2 btn-" + theme_color}
          >
            <i className="fal fa-spinner-third me-2 loading d-none"></i>
            LOGIN
          </button>
          <p>
            Don't have an account?{" "}
            <Link to="/signup">
              <b>SIGN UP</b>
            </Link>
          </p>
        </form>
      </div>
      <Footer />
    </>
  );
}
